import React, { useEffect } from "react";
import { compose } from "redux";
import moment from "moment-mini";
import withPriceAlerts from "../../../../../../hocs/withPriceAlerts";
import withPriceAlertsModal from "../../../../../../hocs/withPriceAlertsModal";
import FormatCurrency from "../../../../landingPage/pages/Homepage/components/FormatCurrency";
import TrashIcon from "./assets/trash.svg";

const PriceAlertsTable = ({
  stockId,
  stockName,
  locale,
  translate,
  priceAlerts,
  fetchPriceAlerts,
  deletePriceAlert,
  renewAlert
}) => {
  const tableTitle = stockName
    ? translate("price-alerts-table_title-with-company", {
        stockName
      })
    : translate("price-alerts-table_title");
  useEffect(() => {
    if (!stockId) {
      return;
    }

    fetchPriceAlerts(stockId);
  }, [stockId, fetchPriceAlerts]);

  if (!priceAlerts?.length) {
    return null;
  }

  return (
    <div className={"flex flex-col p-4 bg-gray rounded"}>
      <h2 className={"line-height-160 text-sm text-black font-medium mb-4"}>
        {tableTitle}
      </h2>
      {priceAlerts.map((alert, index) => (
        <React.Fragment key={alert.id}>
          <div
            className={"grid gap-4 items-start"}
            style={{ gridTemplateColumns: "1fr 4fr 1fr 1fr" }}
          >
            <div className={"flex flex-col gap-2"}>
              <span
                className={"font-medium text-black-9 text-xs line-height-100"}
              >
                {translate("price-alerts-table_price")}
              </span>
              <strong
                className={
                  "font-medium text-black text-xs line-height-100 shrink-0 whitespace-nowrap"
                }
              >
                {FormatCurrency({
                  locale,
                  currency: null,
                  value: alert.price
                })}
              </strong>
            </div>
            <div className={"flex flex-col gap-2"}>
              <span
                className={"font-medium text-black-9 text-xs line-height-100"}
              >
                {translate("price-alerts-table_description")}
              </span>
              <strong
                className={
                  "font-medium text-black text-xs line-height-100 truncate w-full"
                }
              >
                {alert.comment || "-"}
              </strong>
            </div>
            <div className={"flex flex-col gap-2 items-end"}>
              <span
                className={"font-medium text-black-9 text-xs line-height-100"}
              >
                {translate("price-alerts-table_sent")}
              </span>
              <strong
                className={"font-medium text-black text-xs line-height-100"}
              >
                {alert.sent_date ? (
                  <span
                    className={
                      "flex items-center gap-1 shrink-0 whitespace-nowrap"
                    }
                  >
                    {`${moment(alert.sent_date).format("DD.MM.YYYY, HH:mm")}`}
                    <button
                      className={"bg-none border-none p-0 flex text-black"}
                      onClick={() => {
                        renewAlert({
                          id: alert.id,
                          value: alert.price,
                          comment: alert.comment
                        });
                      }}
                    >
                      <i className="fal fa-redo" />
                    </button>
                  </span>
                ) : (
                  translate("price-alerts-table_not-sent")
                )}
              </strong>
            </div>
            <div className={"flex flex-col gap-2 items-end"}>
              <span
                className={"font-medium text-black-9 text-xs line-height-100"}
              >
                {translate("price-alerts-table_delete")}
              </span>
              <button
                className={"bg-none border-none p-0 flex"}
                onClick={() => {
                  deletePriceAlert(stockId, alert.id, false);
                }}
              >
                <img
                  src={TrashIcon}
                  alt={"Trash"}
                  width={16}
                  height={16}
                  className={"shrink-0"}
                />
              </button>
            </div>
          </div>
          {index < priceAlerts.length - 1 ? (
            <div className={"border-bottom border-black-1  my-3"} />
          ) : null}
        </React.Fragment>
      ))}
    </div>
  );
};

export default compose(withPriceAlerts, withPriceAlertsModal)(PriceAlertsTable);
